import React from 'react';
import { Content } from './shared';

const UniversalAnnualWellness = () => (
  <Content>
    Ask your primary care physician if you qualify for a free annual wellness exam.
    <br />
    Good things to have ready:
    <ol>
      <li>Your family's health history.</li>

      <li>Your up-to-date vaccination records.</li>

      <li>
        A list of questions for your physician. Remember, there are no silly questions when it comes
        to your health!
      </li>
    </ol>
  </Content>
);

export default UniversalAnnualWellness;
